import { sportmomentApi } from "~/utils/axios.util";

declare const tokenUnit: string;

export interface SportactiviteitKosten {
    AantalInschrijvingen: number;
    ExtraKosten: boolean;
    ExtraKostenBeschrijving: string
    KostenPerInschrijving: number;
    ServiceKosten: number;
    Korting: number;
    TotaalKosten: number;
}

export interface PaymentMethod {
    Id: number;
    Name: string;
    ImageUrl?: string;
    Beschrijving?: string;
}

class BestelRepository {
    async getAllKosten(sportmomentId: string, platformId: number, aantalPersonen: number, aantalGroepen: number, code?: number) {
        const response = await sportmomentApi.get<SportactiviteitKosten>("api/sportmomentkosten/getallkosten", {
            params: {
                platform: platformId,
                sportmomentId,
                aantalPersonen,
                aantalGroepen,
                code,
            },
        });

        return response.data;
    }



    async getPaymentMethods(sportaanbiederId: string, platformId: number) {
        const response = await sportmomentApi.get<PaymentMethod[]>("api/betaalmodule/getPaymentMethods", {
            params: {
                sportaanbiederId,
                platform: platformId,
            },
        });

        return response.data;
    }

    async inschrijvenGroep(payload: unknown, sportaanbieder: string, guestBooking = false) {
        const method = guestBooking ? "PostGuest" : "Post";
        const headers = guestBooking ? {} : { Authorization: "Bearer " + tokenUnit };
        const response = await sportmomentApi.post(`api/inschrijvinggroep/${method}`, payload, {
            params: {
                sportaanbieder,
            },
            headers,
        });

        return response.data;
    }
}

export default new BestelRepository();
